

















































import { Vue, Component, Prop } from 'vue-property-decorator'
import BytedIconSearch from '@byte-design/vue-icons/icons/Search'
import BytedIconCheckOne from '@byte-design/vue-icons/icons/CheckOne'
import { State } from 'vuex-class'
import { accountRole , getAccountStatusI18n, getAccountStatusColor } from './../const/state/account'

import { TeaConfig } from './../const/dashboard'
import NoData from '@/components/common/no-data.vue'
import { liteForbidden } from './../utils/authUtil'
import { accountStatus } from './../const/state/account'
import PromoteRevalidation from './popup/promote-revalidation.vue'

@Component({
  name: 'AccountList',
  components: {
    BytedIconCheckOne,
    BytedIconSearch,
    NoData,
    PromoteRevalidation,
  }
})

export default class AccountList extends Vue {
  searchItem = '';
  getAccountStatusI18n = getAccountStatusI18n;
  getAccountStatusColor = getAccountStatusColor;
  teaParam = 'setting';
  TeaConfig = TeaConfig;
  showValidationNavigatorPopup = false;
  promoteAccountRole = [accountRole.ROLE_PRE_PROMOTE, accountRole.ROLE_PROMOTE];

  @State('allAccountList', { namespace: 'account' }) allAccountList: any
  @Prop({ default: '', type: String }) chosenId: string

  get filterAccountList(): any {
    return this.allAccountList.filter((item: any) => {
      return item.name.toLowerCase().indexOf(this.searchItem.toLowerCase()) !== -1 ||
        item.id.toLowerCase().indexOf(this.searchItem.toLowerCase()) !== -1
    })
  }

  changeAccount(item: any): void {
    if (+item.role === accountRole.ROLE_BUSINESS_MANAGER) {
      this.$toast(this.$t('common_account_hint'))
      this.$trackEvent('adp_waplite_impression', {
        ...TeaConfig[this.teaParam].accountError
      })
      return
    } else if (+item.role === accountRole.ROLE_PRE_PROMOTE && item.promoteStatus === 2) {
      this.$router.push({ name: 'upgrade', query: { aadvid: item.id } });
      return;
    } else if (+item.role === accountRole.ROLE_PROMOTE && item.status === accountStatus.STATUS_CONFIRM_FAIL)  {
      this.showValidationNavigatorPopup = true;
      return;
    } else if (liteForbidden(item.status)) {
      this.$toast(this.$t('common_account_hint'))
      return
    }
    this.$emit('account-change', item.id)
  }

  async handlePromoteTag() {
    await this.$confirm(this.$t('tt4b_ac_home_promote_update') as string, {
          showCancelButton: false,
          confirmButtonText: this.$t('common_got_it') as string,
          customClass: 'promote-info',
        });
  }

  chosenAccount(id: string): boolean {
    return id === this.chosenId
  }
}
